<script setup>
import { computed } from "vue";
const props = defineProps({
  size: { type: Number, default: 28 },
  inverted: { type: Boolean, default: false },
});

const arrowSrc = computed(() => (props.inverted ? "https://wishlisted.s3.amazonaws.com/images/arrows/arrow-right.svg" : "https://wishlisted.s3.amazonaws.com/images/arrows/arrow-right-black-bg.svg"));
const iconSize = computed(() => props.size * 0.714);
const trackShift = computed(() => -(iconSize.value + 8));
</script>

<template>
  <span
    class="animated-arrow inline-flex shrink-0 items-center overflow-hidden rounded-full"
    :class="inverted ? 'bg-black' : 'bg-primary'"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      paddingLeft: `${(size - size * 0.714) / 2}px`,
    }"
  >
    <span class="animated-arrow__track" :style="{ '--shift': `${trackShift}px` }">
      <img
        :src="arrowSrc"
        alt=""
        class="animated-arrow__icon"
        :style="{ width: `${size * 0.714}px`, height: `${size * 0.714}px` }"
      />
      <img
        :src="arrowSrc"
        alt=""
        class="animated-arrow__icon"
        :style="{ width: `${size * 0.714}px`, height: `${size * 0.714}px` }"
      />
    </span>
  </span>
</template>

<style scoped>
.animated-arrow__track {
  display: flex;
  align-items: center;
  gap: 8px;
  will-change: transform;
  -webkit-transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.animated-arrow__icon {
  flex-shrink: 0;
}

:is(.group:hover, .group:focus-visible) .animated-arrow__track {
  -webkit-transform: translateX(var(--shift));
  transform: translateX(var(--shift));
}
</style>
